import React from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { Form, Button, Container, Row, Col, Card, } from 'react-bootstrap';
// import { motion } from 'framer-motion';
import '../Add-Publisher/AddPublisher.css';
import { InputGroup } from 'react-bootstrap';
import { AiOutlineGlobal } from 'react-icons/ai';

const selectOptions = {
  BillingType: ['ADX', 'ADX+OpenBidding', 'All Demand Channel'],
};

const GoogleAdManager = () => {
     
  const { register, control, handleSubmit, formState: { errors }, } = useForm({ defaultValues: {
      GoogleAdManagers: [
        {
          Domain: '',
          SubDomain: '',
          PayoutPercentage: '',
          BillingType: '',
          NetworkCode: '',
        },
      ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'GoogleAdManagers',
  });

  const onSubmit = (data) => {
    console.log('Submitted Data:', data);
  };

  const renderInput = (name, label, required = false) => (
    <Form.Group controlId={name} className="mb-3">

      <Form.Label className="fw-semibold">
        {label} {required && <span className="text-danger">*</span>}
      </Form.Label>
      <InputGroup>
      <InputGroup.Text><AiOutlineGlobal /></InputGroup.Text>
     
      <Form.Control
        type="text"
        placeholder={`Enter ${label}`}
        {...register(name, { required })}
        className="input-glow"
      />
      {errors[name] && <Form.Text className="text-danger">{label} is required.</Form.Text>}
       </InputGroup>
    </Form.Group>
  );

  const renderSelect = (name, label) => (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label className="fw-semibold">{label}</Form.Label>
      <Form.Select {...register(name)} className="input-glow">
          <option value="">Select {label}</option>
          {selectOptions[label]?.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </Form.Select>
    </Form.Group>
  );

  return (
    <div className="gradient-bg py-3">
      <Container>
        <Card className="shadow-lg border-0 rounded-4">
          <Card.Body className="p-5">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div
                className="mb-5 section-hover-box p-4 rounded border border-1"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2 }}
                whileHover={{ scale: 1.02, boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)' }}
              >
                <h4 className="mb-4 text-secondary border-bottom pb-2 fw-bold sectionHead">
                   <AiOutlineGlobal className="me-2" />
                  Google Ad Manager
                </h4>

                {fields.map((field, index) => (
                  <div
                    key={field.id}
                    className="section-hover-box p-3 rounded border mb-4 bg-light-subtle"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.2, delay: index * 0.05 }}
                    whileHover={{ scale: 1.01 }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="text-primary fw-bold mb-0">Entry #{index + 1}</h5>
                      {fields.length > 1 && (
                        <Button variant="danger" size="sm" onClick={() => remove(index)}>
                          Delete
                        </Button>
                      )}
                    </div>
                    <Row>
                      <Col md={6}>{renderInput(`GoogleAdManagers.${index}.Domain`, 'Domain', true)}</Col>
                      <Col md={6}>{renderInput(`GoogleAdManagers.${index}.SubDomain`, 'SubDomain')}</Col>
                      <Col md={6}>{renderInput(`GoogleAdManagers.${index}.PayoutPercentage`, 'Payout Percentage', true)}</Col>
                      <Col md={6}>{renderSelect(`GoogleAdManagers.${index}.BillingType`, 'BillingType')}</Col>
                      <Col md={6}>{renderInput(`GoogleAdManagers.${index}.NetworkCode`, 'Network Code')}</Col>
                    </Row>
                  </div>
                ))}

                <div className="text-end">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() =>
                      append({
                        Domain: '',
                        SubDomain: '',
                        PayoutPercentage: '',
                        BillingType: '',
                        NetworkCode: '',
                      })
                    }
                  >
                    Add More
                  </Button>
                </div>
              </div>

              <div className="text-center">
                <button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  type="submit"
                  className="btn btn-primary btn-lg px-5"
                >
                  Submit
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default GoogleAdManager;
